import { colors } from '@/theme/colors.theme'
import { utils, writeFile } from 'xlsx-js-style'

export const exportXlsxFile = (headCells, rows, fileName?: string) => {
  const headers = [
    ...headCells.map((item) => ({
      v: item.label,
      s: {
        font: {
          bold: true,
          sz: '14',
          color: { rgb: colors.darker.replace('#', '') },
        },
        border: { bottom: { style: 'thick' } },
      },
    })),
  ]

  const wb = utils.book_new()

  const ws = utils.json_to_sheet([])

  utils.sheet_add_aoa(ws, [headers])

  utils.sheet_add_json(ws, rows, {
    origin: 'A2',
    skipHeader: true,
    header: headCells.map((item) => item.id),
  })

  ws['!cols'] = headCells.map(() => ({ wch: 20 }))

  const range = utils.decode_range(ws['!ref'])

  range.e['c'] = headers.length - 1

  ws['!ref'] = utils.encode_range(range)

  utils.book_append_sheet(wb, ws)

  writeFile(wb, `${fileName || 'download'}.xlsx`)
}
